'use strict';

import dialog from '../../dialog';
import modalExport from '../../modal';
const modal = modalExport.global;
import productStoreInventory from '../../storeinventory/product';
import util from '../../util';
import addToCart from './addToCart';
import availability from './availability';
import image from './image';
//import productNav from './productNav';
import howToSection from './howToSection';
import productSet from './productSet';
import video from '../../video';
import socialShareIcons from './socialShareIcons';
import variant from './variant';
import miniproduct from './miniproduct';
import analytics from '../../analytics';
import compareShades from './compareshades';
import reinsurancePanel from '../reinsurancePanel';
import miniCrossSell from "./../../mini-crosssell";
import reassurance from './../../reassurance';
import fetchCompareProducts from './../../product-compare';


/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    addToCart();
    availability();
    variant();
    image();
    compareShades();
    fetchCompareProducts.init();
    howToSection.init();
    productSet();
    socialShareIcons();
    miniproduct.init();
    ominibusTooltip();
    miniCrossSell.init();
    reassurance.init();
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }
    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });


    $('.full-ingredients').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        var $fullIngredientList = $('.full-ingredients-list');
        var contentUrl = $this.attr('href');

        if ($fullIngredientList.length ) {
            $this.toggleClass('show-list');

        } else {
            $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done( function(content) {
                $('<div class="full-ingredients-list"><a class="close"><i class="icon-close"></i></a>' + content + '</div>').insertAfter($this);
            });
            $this.toggleClass('show-list');
        }



    });

     $pdpMain.on('click', '.close', function(e){
            e.preventDefault();
            $('.full-ingredients.show-list').removeClass('show-list');
        });


    if ($('.product-set-actions').length) {
            var $productForms = $('.product-set-list').find('form').toArray();
            var pids = $productForms.map(function (formEle) {
                return $(formEle).data('pid');
            }).join(',');

            $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
                pid: pids
            }), function (data) {
                if (data === 'false') {
                    $('.product-form-actions .product-set-wishlist').removeClass('hide');
                    $('.product-form-actions .remove-product-set-from-wishlist').addClass('hide');
                } else {
                    $('.product-form-actions .product-set-wishlist').addClass('hide');
                    $('.product-form-actions .remove-product-set-from-wishlist').removeClass('hide');
                }
            });

            $('.remove-product-set-from-wishlist').on('click', function (e) {
                e.preventDefault();

                $.post(util.appendParamsToUrl(Urls.wishlistRemoveAll, {
                    pid: pids
                }), function () {
                    window.location.href = window.location.href;
                })
            });
        }

    $('.size-chart-link a').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
    
    if($('.pdp-jump-links li').length > 3){
    	$('.pdp-jump-links li').addClass('more-than-three-jump-links');
    }

    $(document).on('click', '.pdp-jump-links a', function(e) {
    	e.preventDefault();
    	var $this = $(this);
    	var $li = $this.closest("li");
    	if($li.hasClass("is-open")) {return false;}
    	
    	$li.addClass("is-open").siblings().removeClass("is-open");
    	var $container = $('.pdp-info-tabs .pdp-content');
    	var $toggleFor = $this.attr('href');
    	$('.accordion-toggle', $container).removeClass("is-open").filter("[href='"+$toggleFor+"']").addClass('is-open');
    	$('.pdp-content-section', $container).removeClass('is-open').filter($toggleFor).addClass('is-open');
    });

    $(document).on('click', '.accordion-toggle', function(e) {
        e.preventDefault();
        var $toggleFor = $(this).attr('href');
        var $toggleHeight = $('.accordion-toggle').outerHeight();
        var $stickyHeader = $('.sticky-header').outerHeight();

        var totalOffset = $toggleHeight + $stickyHeader;

        var $container = $('.pdp-info-tabs .pdp-content');
        
        if ( $(this).hasClass('is-open') ) {
            $(this).removeClass('is-open');
            $($toggleFor).removeClass('is-open').slideUp();
            return false;
        }
        else {
            $('.accordion-toggle.is-open', $container).removeClass('is-open');
            $('.pdp-content-section.is-open', $container).removeClass('is-open').slideUp(200);

            $(this).toggleClass('is-open');
            $($toggleFor).toggleClass('is-open').slideDown(function() {
                $('html, body').animate({scrollTop: $(this).offset().top - totalOffset}, 300);
            });
        }

        if ($(this).attr('id') == 'rec-toggle') {
            $('.carousel-recommendations.slick-slider').slick('refresh');
        }
    });

    if($('.pt_product-details').length ){
        setTimeout(() => {
            if ($('[data-bv-show=reviews] #bv_review_maincontainer button').length) {
                document.querySelector('[data-bv-show=reviews] #bv_review_maincontainer button').setAttribute('style', 'display:none');  
            }
        }, 3000);
    }
}

function ominibusTooltip(){
		if($('.ominibus-tooltip').length > 0){
            var ominibusContent = $('.ominibus-tooltip-content');
            $('.ominibus-tooltip #ominibus-show').on('click', function(e){
                e.stopPropagation();
                $(this).closest('.ominibus-tooltip').find(ominibusContent).removeClass('hidden');
            });
            $(ominibusContent).on('click', function(e){
                e.stopPropagation();
            });
            $('.ominibus-tooltip #ominibus-hide').on('click', function(){
                $(this).closest('.ominibus-tooltip').find(ominibusContent).addClass('hidden');
            });
            $('html').on('click', function(){
                !$(ominibusContent).hasClass('.hidden') && $(ominibusContent).addClass('hidden');
            });
        }
}

function setPDPInterrupter() {
    var isDesktop = $(window).width() > 1024;
    if( isDesktop && $('#pdp-interrupter').length ) {
        var $pdp_interrupter = $("#pdp-interrupter");
        var delay = SitePreferences.PDPINTERRUPTER_DELAY && !isNaN(SitePreferences.PDPINTERRUPTER_DELAY) ? SitePreferences.PDPINTERRUPTER_DELAY : 2000;
        window.setTimeout(function() {
            $pdp_interrupter.attr("aria-hidden", false).animate( {marginLeft: 0}, 500 );
        }, delay);
        $pdp_interrupter.on("click", "button.button-close", function() {
            $(this).closest("#pdp-interrupter").addClass("hide").attr("aria-hidden", true);
        });
    }
}

function reinsuranceContent() {
    let maxHeight = 0;
    $('.reinsurance-wrapper').each(function () {
        let titleHeight = $(this).find('.reinsurance-content .reinsurance-title').outerHeight();
        maxHeight = Math.max(maxHeight, titleHeight); // Keep track of the max height
    });
    $('.reinsurance-wrapper').each(function() {
        const $element = $(this);
        const $reinsuranceContent = $element.find('.reinsurance-content');

        $element.prop("disabled", false);
        $element.find(".description-icon").removeClass("hide");

        // Apply height with a delay only if it has "open-reinsurance-panel"
        if ($element.hasClass("open-reinsurance-panel")) {
            setTimeout(function () {
                $reinsuranceContent.css({
                    'height': maxHeight + 50 + 'px',
                    'min-height': maxHeight + 50 + 'px'
                });
            }, 500);
        } else {
            $reinsuranceContent.css({
                'height': maxHeight + 48 + 'px',
                'min-height': maxHeight + 48 + 'px'
            });
        }
    });
	$(document).on('click', '.reinsurance-wrapper', function (e) {
        if($(this).hasClass("open-reinsurance-panel")) {
			$(this).prop("disabled", false);
			var contentAssetId = $(this).attr("data-content-id")
			reinsurancePanel.openReinsurancePanel(contentAssetId);
		} else {
            $(this).find('.reinsuranceDesc').toggleClass('open');
            $(this).find('.plus-icon').toggleClass('hide');
            $(this).find('.minus-icon').toggleClass('show');
            $(this).parents('.reinsurance-checkout-mobile .content-asset').siblings().toggleClass('hide');
            $(this).find('.reinsurance-content').toggleClass('adjust-margin-content');
            $(this).find('.reinsurance-content').css('height', 'auto');
            $(this).closest('.content-asset').toggleClass('reinsurance-margin');
        }

        if ($(this).find('.reinsuranceDesc').hasClass('open') == false) {
            $(this).find('.reinsurance-content').css('height', maxHeight + 45 + 'px');
        }
	});
}

function checkoutReinsurancePopup() {
	$('a.cart-reinsuance-modal').on('click', function(e) {		
		e.preventDefault();
		e.stopImmediatePropagation();
		var $this = $(this);		
		analytics.reinsuranceElements($this.attr('id'));		
		
		$.ajax({
			url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
			method: 'GET'
		})
		.done(function (response) { 
			if (response) {
                modal.addCustomClass('checkout-reinsurance-inner-wrapper');
                modal.renderContent(response);
			}
		});
	});
}

// EER-6885 Multiple promotion message display
function promotionMessageSlider() {
	$('.promo-slider-thumbnail').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.promo-slider-nav'
	});

	$('.promo-slider-nav').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.promo-slider-thumbnail',
		dots: false,
		infinite: true,
		centerMode: false,
		arrows: true,
	});
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeEvents();
        setPDPInterrupter();
        checkoutReinsurancePopup();
        reinsuranceContent();
    }
};

export default product;
